import { Content } from '@backstage/core-components';
import { PageShareTitle } from '../../lib/shareTitle';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { getStoredFunMode, translate } from '../i18n';

/**
 * Secret ref editor tab on component entities that carry the
 * argocd/app-selector annotation. Renders SecretConfigTab inside the standard
 * Content wrapper. Wiring is kept in sync by
 * packages/app/src/modules/configuration/secretEntityContent.test.ts.
 */
export const secretEntityContent = EntityContentBlueprint.make({
  name: 'secret',
  params: {
    path: '/secret',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate(
      'configuration.secretEntityContent.title',
      getStoredFunMode(),
    ),
    group: 'configuration',
    filter: (entity: {
      kind: string;
      metadata: { annotations?: Record<string, string> };
    }) =>
      entity.kind === 'Component' &&
      Boolean(entity.metadata.annotations?.['argocd/app-selector']),
    loader: () =>
      import('./SecretConfigTab').then(m => (
        <PageShareTitle title="Secret configuration">
          <Content>
            <m.SecretConfigTab />
          </Content>
        </PageShareTitle>
      )),
  },
});
